import { Kit, Price } from "./Kit";
export { Kit, Price } from "./Kit";

const elements: Kit = {
    id: "elements",
    name: "Elements",
    overview: "Build your best app yet with the most comprehensive React Native starter kit.",
    // tslint:disable-next-line:max-line-length
    description: "Five demo apps and more than seventy-five beautiful components.",
    price: {
        value: 1950,
        originalPrice: 7500,
        currency: "USD"
    },
    documentation: "https://wcandillon.github.io/react-native-elements",
    color: "#73C700",
    expo: "exp://exp.host/@wcandillon/react-native-elements",
    thumbnail: require("./elements.jpg"),
    thumbnailPreview: require("./elements-preview.jpg"),
    buy: "/elements",
    testFlight: "https://testflight.apple.com/join/u9Ligqwa",
    apk: "https://firebasestorage.googleapis.com/v0/b/react-native-ui-kits.appspot.com/o/builds%2Fandroid%2Freact-native-elements-8ab31b7f4e1e4943bb7978e8201b4596-signed.apk?alt=media&token=ee4c0fbe-5324-4272-b9fb-efb029e38b1f",
};

const rnDo: Kit = {
    id: "do",
    name: "Do",
    overview: "Beautiful starter kit based on Invision's Do",
    // tslint:disable-next-line:max-line-length
    description: "Twelve beautiful screens implemented in React Native for iOS and Android. Integration with Firebase authentication and database is available as well.",
    price: {
        value: 7500,
        currency: "USD"
    },
    documentation: "https://wcandillon.github.io/react-native-do-documentation/",
    thumbnail: require("./do.jpg"),
    thumbnailPreview: require("./do-preview.jpg"),
    color: "#50D2C2",
    expo: "exp://exp.host/@wcandillon/react-native-do-firebase",
    buy: "https://market.nativebase.io/view/react-native-do-with-firebase",
    testFlight: "https://testflight.apple.com/join/GXs7QtFA",
    apk: null
};

const doPurpleSky: Kit = {
    id: "do-purple-sky",
    name: "Do Purple Sky",
    overview: "Slick theme variant of Invision's Do",
    price: {
        value: 7500,
        currency: "USD"
    },
    description: "Twelve beautiful screens and navigation implemented in React Native for iOS and Android.",
    documentation: "https://wcandillon.github.io/react-native-do-purple-sky-documentation/",
    thumbnail: require("./do-purple-sky.jpg"),
    thumbnailPreview: require("./do-purple-sky-preview.jpg"),
    color: "#00BAFF",
    expo: "exp://exp.host/@wcandillon/react-native-do-purple-sky",
    buy: "https://market.nativebase.io/view/react-native-do-purple-sky-theme",
    testFlight: "https://testflight.apple.com/join/pwSBYO3R",
    apk: null
};

const ting: Kit = {
    id: "ting",
    name: "Ting",
    overview: "Complete listing app inspired from Airbnb",
    price: {
        value: 7500,
        currency: "USD"
    },
    // tslint:disable-next-line:max-line-length
    description: "Ting is a flexible React Native theme, best suited for developing online marketplaces and hospitality service apps for both Android and iOS.",
    documentation: "https://wcandillon.github.io/react-native-ting-documentation/",
    thumbnail: require("./ting.jpg"),
    thumbnailPreview: require("./ting-preview.jpg"),
    color: "#F7555c",
    expo: "exp://exp.host/@wcandillon/react-native-ting",
    buy: "https://market.nativebase.io/view/react-native-ting-app",
    testFlight: "https://testflight.apple.com/join/zSUZxjXZ",
    apk: "https://firebasestorage.googleapis.com/v0/b/react-native-ui-kits.appspot.com/o/starter-kits%2Fting%2Fbuild%2Fandroid%2Freact-native-ting-266b6b6f0dc34015bbb59dfb73365642-signed.apk?alt=media&token=24bc1901-22b3-4262-bff6-896174646780"
};

const fiber: Kit = {
    id: "fiber",
    name: "Fiber with Firebase",
    overview: "A starter Kit focused on animations inspired by Framer.",
    price: {
        value: 10000,
        currency: "USD"
    },
    // tslint:disable-next-line:max-line-length
    description: "Fiber is an iOS and Android React Native theme heavily focused on animations. Support Firebase Authentication and Cloud Firestore.",
    documentation: "https://wcandillon.github.io/react-native-fiber/",
    color: "#58b1f1",
    expo: "exp://exp.host/@wcandillon/react-native-fiber-firebase",
    // video: require("./fiber.mp4"),
    thumbnail: require("./fiber.jpg"),
    thumbnailPreview: require("./fiber-preview.jpg"),
    buy: "https://market.nativebase.io/view/react-native-fiber-firebase",
    testFlight: "https://testflight.apple.com/join/TUuAnOpj",
    apk: "https://firebasestorage.googleapis.com/v0/b/react-native-ui-kits.appspot.com/o/starter-kits%2Ffiber%2Fbuilds%2Fandroid%2Freact-native-fiber-firebase-741dd71628f844198b3c3f630583c50a-signed.apk?alt=media&token=e42dcdce-e0d2-44f0-adfc-d2bc4f0dbc4f"
};

export const KITS: Kit[] = [
    elements,
    fiber,
    ting,
    rnDo,
    doPurpleSky
];

const symbols = {
    "USD": "$"
};

export const formatPrice = (price: Price): string => {
    return `${symbols[price.currency]}${price.value / 100}`;
};



// WEBPACK FOOTER //
// ./src/components/kits/index.ts